// CARO. Casa de estilo — analytics abstraction (vendor-agnostic).
// Business logic emits events through track(); the vendor is chosen at runtime.
// Privacy-first: no tracking is sent to a vendor unless one is configured, and
// non-essential trackers must not load before consent where legally required.

export type AnalyticsEvent =
  | 'page_view'
  | 'view_product'
  | 'add_to_cart'
  | 'begin_checkout'
  | 'purchase'
  | 'contact'
  | 'instagram_click'
  | 'newsletter_signup'
  | 'restock_signup'
  // COLORIMETRY ME!: steps only, never answers or results (docs/plan-colorimetry-me.md §1).
  | 'colorimetry_start'
  | 'colorimetry_result'
  | 'colorimetry_score'
  | 'colorimetry_pdf'
  | 'colorimetry_card'
  // COLORIMETRY ME! P2 (Silueta y Rostro, test page): steps only, `block` = silhouette | face.
  | 'style_start'
  | 'style_result'
  | 'style_score'
  | 'style_pdf';

type Props = Record<string, string | number | boolean | null>;

interface AnalyticsSink {
  track(event: AnalyticsEvent, props?: Props): void;
}

// Default no-op sink. Swap for Plausible/Cloudflare Web Analytics later by
// implementing AnalyticsSink and calling setAnalyticsSink().
let sink: AnalyticsSink = {
  track(event, props) {
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.debug('[analytics]', event, props ?? {});
    }
  },
};

export function setAnalyticsSink(next: AnalyticsSink): void {
  sink = next;
}

export function track(event: AnalyticsEvent, props?: Props): void {
  try {
    sink.track(event, props);
  } catch {
    /* analytics must never break the app */
  }
}
